<template>
  <div
    v-if="shouldRender"
    class="business-attributes-widget"
  >
    <div
      v-for="attr in visibleAttributes"
      :key="attr.key"
      class="info-card"
    >
      <label class="label--small">{{ attr.label }}</label>
      <h3 class="heading--xsmall">
        {{ attr.value }}
      </h3>
    </div>
  </div>
</template>

<script>
import { BusinessAttributesCopy } from '@/enums'

export default {
  name: 'BusinessAttributesWidget',
  props: {
    data: {
      type: Object,
      default: () => ({})
    },
    isOwner: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    attributes() {
      return [
        { key: 'entity',          label: BusinessAttributesCopy.LABEL_ENTITY,            value: this.data.entity },
        { key: 'yearsInBusiness', label: BusinessAttributesCopy.LABEL_YEARS_IN_BUSINESS, value: this.data.yearsInBusiness },
        { key: 'companySize',     label: BusinessAttributesCopy.LABEL_COMPANY_SIZE,      value: this.data.companySize },
        { key: 'annualRevenue',   label: BusinessAttributesCopy.LABEL_ANNUAL_REVENUE,    value: this.data.annualRevenue },
      ]
    },
    visibleAttributes() {
      return this.attributes.filter(({ value }) => value !== null && value !== undefined && value !== '')
    },
    shouldRender() {
      return this.isOwner || this.visibleAttributes.length > 0
    },
  },
}
</script>

<style scoped lang="scss">
.business-attributes-widget {
  @include inline-space($space-small);
  padding: $space-medium $space-medium $space-large;
  align-items: flex-start;
  align-content: flex-start;
  align-self: stretch;
  flex-wrap: wrap;
  gap: $space-small;

  .info-card {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    min-height: 75px;
    padding: $space-medium;
    flex: 1 0 0;
    color: $color-text-primary-alt;
    border-radius: $radius-medium;
    background-color: $color-neutral-darkest;

    .heading--xsmall {
      word-break: break-word;
    }
  }

  
  @media (max-width: $mobile-breakpoint-max-width) {
    .info-card {
      flex: 1 0 50%;
    }
  }
}
</style>